export default function MediaInfoRow({

    icon,

    label,

    value,

    children

}) {

    return (

        <div className="media-info-row">

            <div className="media-info-label">

                {

                    icon &&

                    <span className="media-info-icon">

                        {icon}

                    </span>

                }

                <span>

                    {label}

                </span>

            </div>

            <div className="media-info-value">

                {

                    children ||

                    value ||

                    "-"

                }

            </div>

<style>{`

.media-info-row{

    display:flex;

    justify-content:space-between;

    align-items:center;

    gap:20px;

    padding:14px 0;

    border-bottom:1px solid #F1F5F9;

}

.media-info-row:last-child{

    border-bottom:none;

}

.media-info-label{

    display:flex;

    align-items:center;

    gap:10px;

    min-width:150px;

    color:#64748B;

    font-size:13px;

    font-weight:600;

}

.media-info-icon{

    width:30px;

    height:30px;

    border-radius:8px;

    display:flex;

    align-items:center;

    justify-content:center;

    background:#F8FAFC;

    color:#64748B;

    flex-shrink:0;

}

.media-info-value{

    flex:1;

    text-align:right;

    color:#111827;

    font-size:14px;

    font-weight:500;

    word-break:break-word;

}

`}</style>

        </div>

    );

}